<template>
<div class="chapter">
<div class="inner_page">
<p class="Basic-Paragraph para-style-override-2"></p>
<p class="Basic-Paragraph para-style-override-12"><span class="char-style-override-6">And Cain talked with Abel his brother: and it came to pass, when they were in the field, that Cain rose up against Abel his brother, and slew him.</span></p>
<p class="Basic-Paragraph para-style-override-13">—Genesis 4:8</p>
<p class="x-2-chapter para-style-override-3"></p>
<p class="x-1-title"></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// SIDP_FM01_0003_0001.vue?2a32a766